<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 40 40"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect :fill="rectFill" height="40" width="40"/>
    <path d="M29 11.6V28.4C29 28.7314 28.7314 29 28.4 29H11.6C11.2686 29 11 28.7314 11 28.4V11.6C11 11.2686 11.2686 11 11.6 11H28.4C28.7314 11 29 11.2686 29 11.6Z" stroke="black" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
    <path d="M17 20H20M20 20H23M20 20V17M20 20V23" :stroke="stroke" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
  </svg>
</template>

<script>
export default {
  name: 'ImageControlZoomIn',
  props: {
    width: {
      type: String,
      required: false,
      default: '40'
    },
    height: {
      type: String,
      required: false,
      default: '40'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
    stroke: {
      type: String,
      required: false,
      default: '#000'
    },
    rectFill: {
      type: String,
      required: false,
      default: '#FFF'
    },
  },
};
</script>
